import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import PostUploadsBlock from "../Posts/PostUploadsBlock/PostUploadsBlock";
import PostActions from "./PostActions";
import CollapsibleText from "./CollapsibleText";
import PostComment from "./PostComment";
import { setSender, setReceiver, setOrg, findOwner, fillProjectsData, fillProjectsDataContent } from "../Helpers/Functions/TemplateVariables";

export default function CardPostList(props) {
  const [posts, setPosts] = useState(props.posts);
  const [originalPosts, setOriginalPosts] = useState(props.posts.map(post => ({ ...post }))); // Shallow copy
  const current_user = props.current_user
  const team = props.team
  const users = props.users
  const manager = (window.clarity.cu.type == 'manager' || window.clarity.cu.type == 'assistant_manager');
  const currentUserId = window.clarity.cu.id;
  const usingApprovals = window.clarity.ct.ua;
  const [page, setPage] = useState(1);
  const commentIntent = props.comment
  const fromProjects = props.from_projects ? true : false

  const preview = props.preview || false;
  let uploadDisplayLimit = null;

  if (preview) {
    uploadDisplayLimit = 4;
  }

  const currentPage = props.currentPage;

  const showApprovalMessage = (post) => {
    if (!usingApprovals) {
      return false;
    }

    if (manager) {
      return true;
    }

    if (currentUserId == post.user_id) {
      return true;
    }

    if ((current_user.user_type == "project_manager" || current_user.user_type == 'project_coordinator') && post.project && post.project.name) {
      return true
    }

    if (current_user.user_type == 'sponsorship_manager') {
      return true
    }

    return false;
  }

  const updatePost = (post, update) => {
    setPosts([...posts].map(object => {
      if(object.id === post.id) {
        return {
          ...object,
          ...update
        }
      }
      else return object;
    }))
  }

  const getOriginalObject = (id) => {
    let post = originalPosts.find(p => p.id == id)
    if (post && post.title) {
      return {title: post.title, content: post.content}
    }
    return null
  }

  const postItems = []
  for (const [index, post] of posts.entries()) {
    let obj = getOriginalObject(post.id)
    let updatedPost = {...post}
    if (obj) {
      updatedPost = {...post, title: obj.title, content: obj.content}
    }
    let title = post.title

    updatedPost.safe_content = setOrg(post, team)
    updatedPost.title = updatedPost.title.replace(/{{organization.name}}/g, team.name)

  if (post.project_id == null) {
    let postOwner = post.user.user_info
    setSender(updatedPost, postOwner)

    // if post owner is a donor and viewer is a beneficiary
    if (current_user.user_type == 'beneficiary' && postOwner.user_type == 'donor') {
      setReceiver(updatedPost, current_user)
    } else if (current_user.user_type == 'donor' && postOwner.user_type == 'beneficiary') {
      setReceiver(updatedPost, current_user)
    } else if (postOwner.user_type == 'manager' && current_user.user_type !== 'manager'){
      setReceiver(updatedPost, current_user)
    } else if (postOwner.user_type == 'assistant_manager' && current_user.user_type !== 'assistant_manager'){
      setReceiver(updatedPost, current_user)
    } else if (postOwner.user_type == 'project_manager' && current_user.user_type !== 'project_manager'){
      setReceiver(updatedPost, current_user)
    } else if (postOwner.user_type == 'project_coordinator' && current_user.user_type !== 'project_coordinator'){
      setReceiver(updatedPost, current_user)
    } else if (postOwner.user_type == 'sponsorship_manager' && current_user.user_type !== 'sponsorship_manager'){
      setReceiver(updatedPost, current_user)
    }
  }

  if (post.user_id == null) {
    fillProjectsData(updatedPost)
    updatedPost.safe_content = fillProjectsDataContent(updatedPost)
    if (current_user.user_type == 'beneficiary' || current_user.user_type == 'donor') {
      setReceiver(updatedPost, current_user)
    }
  }

    let content = updatedPost.safe_content;
    post.title = <span dangerouslySetInnerHTML={{__html: updatedPost.title}} />

   


    if (preview) {
      content = <CollapsibleText content={content} />
    } else {
      content = <div dangerouslySetInnerHTML={{__html: content }} />
    }

    postItems.push(
      <div key={post.id}>
      <div className="card card--post">
        <div className="card-header">
          <div className="card-title d-flex align-items-center justify-content-between">
            <div>
              {post.user_id !== null &&
              <div className="card--name-title">
              <a href={post.user_profile_url}><strong>{post.user.visible_name}</strong></a> · <a href={post.url}>{post.title}</a>
              </div>}
              {post.user_id == null &&
              <div className="card--name-title">
              <a href={post.user_profile_url}><strong>{post.project.name}</strong></a> · <a href={post.url}>{post.title}</a>
              </div>}
              <div className="card--post-time-ago">
                <span className="mr-1">
                  {post.created_at_in_words}
                </span>

                {post.audience_members && post.audience_members.length > 0 && (
                  <span>
                    <span className="ml-1 mr-2">·</span>
                      <i className="fa-user-lock far" title='Audience'></i> {post.audience_names}
                    {post.ordered_uploads.length > 0 && (<span className="ml-2 mr-1">·</span>)}
                 </span>
                )}

                {post.ordered_uploads.length > 0 && (
                  <span className="badge badge-sm badge-primary badge-pill ml-1">
                    {post.ordered_uploads.length} Uploads
                  </span>
                )}

                {showApprovalMessage(post) && (
                  <React.Fragment>
                    {!post.approved_at && (<div className="post--approval text-danger">
                      <i className="fa fa-exclamation fa-exclamation-circle"></i> Waiting on approval and can continue to be edited
                    </div>)}
                    {post.approved_at && (<div className="post--approval text-success">
                      <i className="fa fa-check fa-check-circle"></i> Post approved and cannot be edited anymore
                    </div>)}
                  </React.Fragment>
                )}
                {post.show_in_pages && post.project_id && manager &&
                  <div><i class="far fa-eye text-blue"></i> Will show in associated public pages</div>
                }
                { fromProjects && post.pinned &&
                  <div><i class="fas fa-thumbtack"></i> Pinned</div>
                }
              </div>
            </div>

            <PostActions 
              post={post} 
              updatePost={updatePost} 
              currentPage={currentPage} 
              templates={props.templates} 
              user={current_user} 
              fromProjects={fromProjects}
            />
          </div>
        </div>
        <div className="card-body">
          <div>
            {content}
          </div>

          <PostUploadsBlock uploads={post.ordered_uploads} limit={uploadDisplayLimit} />

          {(post.user_id !== null || post.project_id !== null) &&
            <div className="w-100 text-right">
              <a href={post.url} className="card-link text-right">
                { post.comments.count ? post.comments.count : 0 } comments
              </a>
            </div>
          }
        </div>

        {preview && post.ordered_uploads && post.ordered_uploads.length > uploadDisplayLimit && (
          <div className="card-footer">
            <a href={post.url}>
              +{post.ordered_uploads.length - uploadDisplayLimit} more...
            </a>
          </div>)
        }
      </div>
      </div>
    )
  }


  return (
    <React.Fragment>
      {current_user.user_type == 'manager' || current_user.user_type == 'assistant_manager' && props.group_post &&
      <div className="cu-dashboard-p">
      <small>
          <span onClick={() => {window.location = '/group/post'}} className="badge badge-sm badge-primary badge-pill ml-1"><b>Multiple Post Pending</b></span>
      </small>
      </div>
      }
      <div>
        {postItems}
      </div>

      {commentIntent && (posts[0].user_id || posts[0].project_id) &&
        <PostComment post={posts[0]} current_user={current_user}/>
      }
    </React.Fragment>
  );
}

CardPostList.propTypes = {
  posts: PropTypes.array
};
